import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';

import { ToastNotificationsService } from '@notifications/services/toast-notifications.service';

export const UNAUTHORIZED_INTERCEPTOR: HttpInterceptorFn = (req, next) => {
  const toastNotificationsService = inject(ToastNotificationsService);

  return next(req).pipe(
    tap({
      error: (error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 403) {
          toastNotificationsService.error(
            'You have no rights to perform this action.'
          );
        }
      }
    })
  );
};
